<template>
    <div>
        <div class="">
            <h1 class="title is-1">{{ $t('menu.history') }}</h1>
        </div>
        
        <div class="section">
            <div class="content">
                <h2 class="title is-2">
                    {{$t('history.ch1_title')}}
                </h2>
                <p>{{ $t('history.ch1_p1') }}</p>
                <p>{{ $t('history.ch1_p2') }}</p>
                <p>{{ $t('history.ch1_p3') }}</p>
                <p>{{ $t('history.ch1_p4') }}</p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[5]"  @click="openImage(5)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[6]"  @click="openImage(6)"/>
                    </div>
                </div>
                <p>{{ $t('history.ch1_p5') }}</p>
                <p>{{ $t('history.ch1_p6') }}</p>
                <h2 class="title is-2">
                    {{$t('history.ch2_title')}}
                </h2>
                <p>{{ $t('history.ch2_p1') }}</p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[1]"  @click="openImage(1)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[2]"  @click="openImage(2)"/>
                    </div>
                </div>
                <p>{{ $t('history.ch2_p2') }}</p>
                <p>{{ $t('history.ch2_p3') }}</p>
                <div class="columns">
                    <div class="column">
                        <img :src="images.sprite[3]"  @click="openImage(3)"/>
                    </div>
                    <div class="column">
                        <img :src="images.sprite[4]"  @click="openImage(4)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../event-bus.js'

    export default {
        data(){
            return {
                images: null
            }
        },
        methods: {
            openImage(index){
                EventBus.$emit('openGallery', this.images.full, index)
            },
            createDemoImages(){
                var images = {}
                images['full'] = []
                images['sprite'] = []

                for(var i = 0; i < 8; i++){
                    var url = "img/history/pic"+i+".jpg"
                    images['full'][i] = url
                    images['sprite'][i] = url
                }
                this.images = images
            }
        },
        created(){
            this.createDemoImages()
        }
    }
</script>